<template>
  <m-base-menu-500 data-slot="default" :menu-position="menuPosition" id="menu-3">
    <slot></slot>
  </m-base-menu-500>
</template>

<script>
import {MenuProps} from "./MenuProps";
import mBaseMenu500 from "./BaseMenu500";

export default {
  name: "Menu3",
  components: {mBaseMenu500},
  props: {
    ...MenuProps
  }
}
</script>
<style scoped>
#menu-3 :deep(.menu-item-wrapper) {
  display: inline-block;
  text-align: center;
}

#menu-3 :deep(.base-menu-item-icon) {
  display: block;
}
</style>

